function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getCartId } from "../../utils/product";
export var getCompositeAddonKey = function(addonParams) {
    return [
        "id",
        "parentId",
        "parentCartId",
        "sourceRowId",
        "sourceOptionId"
    ].map(function(k) {
        return addonParams[k];
    }).join("|");
};
export var getAddonsFromSelections = function(cart, allAddonItems, existingSelectedAddons) {
    var addonParams = [];
    cart.forEach(function(item) {
        item.rows.forEach(function(row) {
            var ref, ref1, ref2;
            if (!((ref = row.options) === null || ref === void 0 ? void 0 : ref.usesAddOnItems)) return;
            (ref1 = item.values[row.id]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.forEach) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, function(selection) {
                var ref;
                var parsedSelection = JSON.parse(selection);
                var parsedValue = JSON.parse(parsedSelection.value);
                (ref = parsedValue.items) === null || ref === void 0 ? void 0 : ref.forEach(function(conf) {
                    if (!conf.requireConfiguration) return;
                    addonParams.push({
                        id: conf.itemId,
                        parentId: item.id,
                        parentCartId: item.cartId,
                        sourceRowId: row.id,
                        sourceOptionId: parsedSelection.id
                    });
                });
            });
        });
    });
    var existingSelectedAddonsByKey = (existingSelectedAddons || []).reduce(function(memo, addon) {
        var key = getCompositeAddonKey(addon);
        memo[key] = memo[key] || addon;
        return memo;
    }, {});
    var selectedAddons = addonParams.map(function(params) {
        var existingAddon = existingSelectedAddonsByKey[getCompositeAddonKey(params)];
        if (existingAddon) return existingAddon;
        var addon = allAddonItems.find(function(addon) {
            return addon.id === params.id;
        });
        return _objectSpreadProps(_objectSpread({}, addon, params), {
            addonId: getCartId()
        });
    });
    return selectedAddons;
};
